const store = {
    namespaced: true,
    state() {
        return {
            settlement: null,
            deliveryType: null,
            orderId: 0,
            payForm: null,
            payOnline: false
        };
    },
    getters: {},
    mutations: {
        setSettlement(state, data) {
            state.settlement = data;
        },
        setDeliveryType(state, data) {
            state.deliveryType = data;
        },
        setOrderId(state, data) {
            state.orderId = data;
        },
        setPayForm(state, data) {
            state.payForm = data;
        },
        setPayOnline(state, data) {
            state.payOnline = data;
        }
    },
    actions: {}
};

export default store;
